import { getAppRole } from '@hb/shared'
import { useMemo } from 'react'
import { useApp } from '../contexts/AppContext'
import { usePracticeAccess } from '../contexts/PracticeAccess/PracticeAccessProvider'
import { useAuth } from '../store/auth'

export const useAppRole = () => {
  const { appName } = useApp()
  const authUser = useAuth(s => s.authUser)
  const claims = useAuth(s => s.claims)

  const { selectedPracticeId } = usePracticeAccess()

  return useMemo(
    () => getAppRole(appName, authUser?.uid ?? null, claims, selectedPracticeId),
    [appName, authUser, claims, selectedPracticeId],
  )
}
